import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import RightArrow from "../../images/Svg/ArrowIcon.svg";
import LeftArrow from "../../images/Svg/LeftBalckArrow.svg";
import facebook from "../../images/Svg/facebook.svg";
import twiiter from "../../images/Svg/Twiiter.svg";
import BlogDown from "../../components/Blog/BlogDown.component";
import { BlogData } from "./Blog.data";
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookShareCount,
} from "react-share";
import { FacebookIcon, TwitterIcon } from "react-share";
import Helmet from "react-helmet";
import { Fade } from "react-reveal";

const parse = require("html-react-parser");

const BlogDetails = () => {
  const { id } = useParams();
  const convertId = parseInt(id);
  let navigate = useNavigate();
  let paramId = convertId + 1;
  let paramMinus = convertId - 1;

  const handleNext = () => {
    navigate(`/blogs/${paramId}`);
  };
  const handleGoBack = () => {
    navigate(`/blogs/${paramMinus}`);
  };
  const filterData = BlogData.filter((data) => data.id !== paramId);
  return (
    <>
      <Helmet>
        <title>{BlogData[convertId]?.title}</title>

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@setu-deso" />
        <meta name="twitter:title" content={`${BlogData[convertId]?.title}`} />
        <meta
          name="twitter:description"
          content={`${BlogData[convertId]?.text}`}
        />
        <meta
          name="twitter:image"
          content={`${BlogData[convertId]?.photoLink}`}
        />
      </Helmet>
      <section>
        <div className="mx-6 sm:mx-6 md:mx-auto max-w-[558px] mt-[24px]">
          {BlogData[convertId]?.title && (
            <>
              {BlogData[convertId]?.title && (
                <h1 className="text-[36px] sm:text-[36px] md:text-[48px]  text-[#000000] font-bold mb-8">
                  {" "}
                  {parse(BlogData[convertId]?.title)}
                </h1>
              )}
              <div className="flex items-center mb-6">
                <p className="mx-2 text-[#000000] text-[18px]">Share </p>
                <div className="flex items-center">
                  <FacebookShareButton
                    url={`https://web3setu.com/blogs/${id}`}
                    description={BlogData[convertId]?.title}
                    hashtag={["#setu_blog", "#web_blog"]}
                    className="Demo__some-network__share-button"
                  >
                    <img
                      className="w-[24px] h-[24px] mx-2"
                      src={facebook}
                      alt=""
                    />
                  </FacebookShareButton>
                  <TwitterShareButton
                    url={`https://web3setu.com/blogs/${id}`}
                    hashtags={["web3_blog", "setu_blog"]}
                  >
                    <img className="w-[24px] h-[24px]" src={twiiter} alt="" />
                  </TwitterShareButton>
                </div>
              </div>
              {BlogData[convertId]?.photo && (
                <img
                  className="w-full mb-[16px]"
                  src={BlogData[convertId]?.photo}
                  alt=""
                />
              )}

              {BlogData[convertId]?.credit && (
                <div className="text-right  mb-8">
                  <a
                    className="text-[16px]  text-[#585858]"
                    href={BlogData[convertId]?.creditLink}
                    target={"_blank"}
                  >
                    {BlogData[convertId]?.credit}
                  </a>
                </div>
              )}

              {BlogData[convertId]?.description &&
                parse(BlogData[convertId]?.description)}
              {BlogData[convertId]?.tags && (
                <div>
                  Tags :
                  {BlogData[convertId]?.tags.map((data) => (
                    <p className="blog-tags mt-4">{data}</p>
                  ))}
                </div>
              )}
              {BlogData[convertId]?.description && (
                <div className="flex justify-between mt-8 items-center">
                  {id == 0 && <div></div>}
                  {id != 0 && (
                    <div
                      onClick={handleGoBack}
                      className="flex items-center cursor-pointer"
                    >
                      <img
                        className="w-[12px] h-[10px]"
                        src={LeftArrow}
                        alt=""
                      />{" "}
                      <p className="mx-2 text-[16px]">Go Back</p>{" "}
                    </div>
                  )}
                  <div className="flex items-center">
                    <p className="mx-2 text-[#000000] text-[18px]">Share </p>
                    <div className="flex items-center">
                      <FacebookShareButton
                        url={`https://web3setu.com/blogs/${id}`}
                        hashtag={"#setu_blog"}
                        className="Demo__some-network__share-button"
                      >
                        <img
                          className="w-[24px] h-[24px] mx-2"
                          src={facebook}
                          alt=""
                        />
                      </FacebookShareButton>
                      <TwitterShareButton
                        url={`https://web3setu.com/blogs/${id}`}
                        hashtags={["web3_blog", "setu_blog"]}
                      >
                        <img
                          className="w-[24px] h-[24px]"
                          src={twiiter}
                          alt=""
                        />
                      </TwitterShareButton>
                    </div>
                  </div>
                  {BlogData.length != paramId && (
                    <div
                      onClick={handleNext}
                      className="flex  items-center cursor-pointer"
                    >
                      <p className="mx-2 text-[16px]">Next</p>{" "}
                      <img
                        className="w-[12px] h-[10px]"
                        src={RightArrow}
                        alt=""
                      />
                    </div>
                  )}
                  {BlogData.length == paramId && <div></div>}
                </div>
              )}
            </>
          )}
        </div>
        {BlogData[convertId]?.title && (
          <div className="container mx-auto text-white my-4 px-6 sm:px-6 md:px-24 items-center mt-[100px]">
            <h1 className="text-[36px] text-[#000000] font-bold mb-8">
              You May Also Like
            </h1>
            <BlogDown data={filterData} />
          </div>
        )}
      </section>
    </>
  );
};

export default BlogDetails;
